import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
import { useParallaxAnimal } from '../useHooks/useParallaxAnimal';

const QuietPower = () => {
    const { t } = useLang('Delta3AirSeries.QuietPower');
    useParallaxAnimal('#D3A-QuietPower .bg-wrap', '#D3A-QuietPower');
    return (
        <section className={`${styles.QuietPower} GtmModuleData-section range7`} id="D3A-QuietPower" data-section-id={'D3A-QuietPower'}>
            <div className="bg-wrap">
                <EcoImg
                    className="bg-img"
                    pc="https://websiteoss.ecoflow.com/upload/image/1763463180037/quite-bg-1.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1763463180225/quite-bg-1-m.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1763463180225/quite-bg-1-m.jpg"
                ></EcoImg>
            </div>
            <div className="content-wrap">
                <div className="text-box">
                    <div className="top-text">{t('title')}</div>
                    <div className="bottom-text">
                        <div className="left">
                            <div className="db-num">{t('db_num')}</div>
                            <div className="quite">{t('quite')}</div>
                        </div>
                        <div className="right">{t('desc')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuietPower;
